import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import SensorsOutlinedIcon from '@mui/icons-material/SensorsOutlined'
import { SectionDefinition } from '../../../components/Sections/Sections.types'

export enum WeatherGroupSectionIds {
  general = 'general',
  source = 'source',
}

/**
 * @description Sections shared by the Weather Group detail page and edit form, in display order.
 */
export const weatherGroupSections: SectionDefinition[] = [
  {
    id: WeatherGroupSectionIds.general,
    title: 'General',
    description: 'Name, and whether the group feeds the status algorithm or the weather shown in the app.',
    icon: InfoOutlinedIcon,
  },
  {
    id: WeatherGroupSectionIds.source,
    title: 'Weather Source',
    description: 'The provider this group gathers weather records from, and the station or coordinates to use.',
    icon: SensorsOutlinedIcon,
  },
]
